import React from 'react';
import SettingsSaveButton from '../SettingsSaveButton';
import { useLanguage } from '../../../../i18n/LanguageContext';

const RustikSettings = React.memo(({
  rustikExtras,
  setRustikExtras,
  isRustikSettingsCollapsed,
  setIsRustikSettingsCollapsed,
  isRustikModelCollapsed,
  setIsRustikModelCollapsed,
  isRustikCapCollapsed,
  setIsRustikCapCollapsed,
  isRustikUzunlukCollapsed,
  setIsRustikUzunlukCollapsed,
  isRustikRenkCollapsed,
  setIsRustikRenkCollapsed,
  newRustikModel,
  setNewRustikModel,
  newRustikCap,
  setNewRustikCap,
  newRustikUzunluk,
  setNewRustikUzunluk,
  newRustikRenk,
  setNewRustikRenk,
  editingRustikModel,
  setEditingRustikModel,
  editingRustikCap,
  setEditingRustikCap,
  editingRustikUzunluk,
  setEditingRustikUzunluk,
  editingRustikRenk,
  setEditingRustikRenk,
  handleSaveSettings,
  isSavingSettings
}) => {
  const { t } = useLanguage();

  return (
    <div className="settings-card">
      <div
        className="settings-header clickable"
        onClick={() => setIsRustikSettingsCollapsed(!isRustikSettingsCollapsed)}
      >
        <div className="settings-title">
          <i className="fas fa-ellipsis-h"></i>
          <span>{t('productList.rustikSettings.title', 'Rustik Ayak Ücret Ayarları')}</span>
        </div>
        <i className={`fas fa-chevron-${isRustikSettingsCollapsed ? 'down' : 'up'}`}></i>
      </div>

      {!isRustikSettingsCollapsed && (
        <div className="settings-content">
          {/* Genel Fiyatlandırma Kartı - Senior UI */}
          <div className="pricing-setup-card" style={{ 
            background: '#f8fafc', 
            borderRadius: '16px', 
            padding: '24px', 
            marginBottom: '28px', 
            border: '1px solid #e2e8f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '20px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={{ 
                background: '#fff', 
                color: '#b04309', 
                width: '48px', 
                height: '48px', 
                borderRadius: '12px', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                fontSize: '1.4rem',
                boxShadow: '0 4px 12px rgba(176, 67, 9, 0.12)',
                border: '1px solid #fff5f0'
              }}>
                <i className="fas fa-coins"></i>
              </div>
              <div>
                <h4 style={{ margin: 0, fontSize: '1.05rem', fontWeight: '700', color: '#1e293b' }}>
                  {t('productList.rustikSettings.defaultFootPrice', 'Varsayılan Ayak Ücreti')}
                </h4>
                <p style={{ margin: '4px 0 0 0', fontSize: '0.85rem', color: '#64748b', maxWidth: '350px' }}>
                  {t('productList.rustikSettings.defaultFootPriceDesc', 'Rustik siparişlerinde kullanılacak standart ayak birim fiyatı. Bu değer sipariş formuna otomatik yansır.')}
                </p>
              </div>
            </div>

            <div className="price-input-container" style={{ minWidth: '180px' }}>
              <div className="price-input-wrapper" style={{ position: 'relative' }}>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  placeholder="0.00"
                  value={rustikExtras.ayakPrice || ''}
                  onChange={(e) => setRustikExtras({ ...rustikExtras, ayakPrice: e.target.value })}
                  style={{ 
                    padding: '12px 16px 12px 40px', 
                    fontSize: '1.2rem', 
                    fontWeight: '700',
                    height: '52px',
                    borderRadius: '12px',
                    border: '2px solid #e2e8f0',
                    width: '100%',
                    color: '#b04309',
                    transition: 'all 0.2s ease',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.02)'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#b04309'}
                  onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                />
                <span style={{ 
                  position: 'absolute', 
                  left: '16px', 
                  top: '50%', 
                  transform: 'translateY(-50%)', 
                  color: '#94a3b8',
                  fontWeight: '700',
                  fontSize: '1.1rem'
                }}>€</span>
              </div>
            </div>
          </div>

          <div className="settings-grid">
            {/* Ayak Modeli Listesi */}
            <div className="settings-column">
              <div
                className="settings-sub-header clickable"
                onClick={() => setIsRustikModelCollapsed(!isRustikModelCollapsed)}
              >
                <h4><i className="fas fa-couch"></i> {t('productList.rustikSettings.footModelList', 'Ayak Model Listesi')}</h4>
                <i className={`fas fa-chevron-${isRustikModelCollapsed ? 'down' : 'up'}`}></i>
              </div>

              {!isRustikModelCollapsed && (
                <div className="settings-sub-content">
                  <div className="list-add-form">
                    <input
                      type="text"
                      placeholder={t('productList.rustikSettings.newModelPlaceholder', 'Yeni Model')}
                      value={newRustikModel}
                      onChange={(e) => setNewRustikModel(e.target.value)}
                    />
                    <button onClick={() => {
                      if (!newRustikModel) return;
                      const newList = [...rustikExtras.ayakModelList, newRustikModel];
                      setRustikExtras({ ...rustikExtras, ayakModelList: newList });
                      setNewRustikModel('');
                      handleSaveSettings({ rustikAyakModelList: newList });
                    }}><i className="fas fa-plus"></i></button>
                  </div>
                  <div className="settings-list-container">
                    {rustikExtras.ayakModelList.length === 0 && <span className="empty-list-msg">{t('productList.dikeySettings.emptyList', 'Liste boş')}</span>}
                    <ul className="settings-inner-list">
                      {rustikExtras.ayakModelList.map((item, index) => (
                        <li key={index} className="settings-list-item">
                          {editingRustikModel.index === index ? (
                            <div className="edit-mode-container">
                              <input
                                type="text"
                                value={editingRustikModel.value}
                                onChange={(e) => setEditingRustikModel({ ...editingRustikModel, value: e.target.value })}
                                autoFocus
                              />
                              <div className="edit-actions">
                                <button className="btn-confirm" onClick={() => {
                                  const newList = [...rustikExtras.ayakModelList];
                                  newList[index] = editingRustikModel.value;
                                  setRustikExtras({ ...rustikExtras, ayakModelList: newList });
                                  handleSaveSettings({ rustikAyakModelList: newList });
                                  setEditingRustikModel({ index: null, value: '' });
                                }}><i className="fas fa-check"></i></button>
                                <button className="btn-cancel" onClick={() => setEditingRustikModel({ index: null, value: '' })}><i className="fas fa-times"></i></button>
                              </div>
                            </div>
                          ) : (
                            <>
                              <span className="item-text">{item}</span>
                              <div className="item-actions">
                                <button className="btn-edit" onClick={() => setEditingRustikModel({ index, value: item })}><i className="fas fa-edit"></i></button>
                                <button className="btn-delete" onClick={() => {
                                  const newList = rustikExtras.ayakModelList.filter((_, i) => i !== index);
                                  setRustikExtras({ ...rustikExtras, ayakModelList: newList });
                                  handleSaveSettings({ rustikAyakModelList: newList });
                                }}><i className="fas fa-trash-alt"></i></button>
                              </div>
                            </>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>

            {/* Ayak Çap Listesi */}
            <div className="settings-column">
              <div
                className="settings-sub-header clickable"
                onClick={() => setIsRustikCapCollapsed(!isRustikCapCollapsed)}
              >
                <h4><i className="fas fa-ruler-combined"></i> {t('productList.rustikSettings.footDiameterList', 'Ayak Çap Listesi')}</h4>
                <i className={`fas fa-chevron-${isRustikCapCollapsed ? 'down' : 'up'}`}></i>
              </div>

              {!isRustikCapCollapsed && (
                <div className="settings-sub-content">
                  <div className="list-add-form">
                    <input
                      type="text"
                      placeholder={t('productList.rustikSettings.newDiameterPlaceholder', 'Yeni Çap')}
                      value={newRustikCap}
                      onChange={(e) => setNewRustikCap(e.target.value)}
                    />
                    <button onClick={() => {
                      if (!newRustikCap) return;
                      const newList = [...rustikExtras.ayakCapList, newRustikCap];
                      setRustikExtras({ ...rustikExtras, ayakCapList: newList });
                      setNewRustikCap('');
                      handleSaveSettings({ rustikAyakCapList: newList });
                    }}><i className="fas fa-plus"></i></button>
                  </div>
                  <div className="settings-list-container">
                    {rustikExtras.ayakCapList.length === 0 && <span className="empty-list-msg">{t('productList.dikeySettings.emptyList', 'Liste boş')}</span>}
                    <ul className="settings-inner-list">
                      {rustikExtras.ayakCapList.map((item, index) => (
                        <li key={index} className="settings-list-item">
                          {editingRustikCap.index === index ? (
                            <div className="edit-mode-container">
                              <input
                                type="text"
                                value={editingRustikCap.value}
                                onChange={(e) => setEditingRustikCap({ ...editingRustikCap, value: e.target.value })}
                                autoFocus
                              />
                              <div className="edit-actions">
                                <button className="btn-confirm" onClick={() => {
                                  const newList = [...rustikExtras.ayakCapList];
                                  newList[index] = editingRustikCap.value;
                                  setRustikExtras({ ...rustikExtras, ayakCapList: newList });
                                  handleSaveSettings({ rustikAyakCapList: newList });
                                  setEditingRustikCap({ index: null, value: '' });
                                }}><i className="fas fa-check"></i></button>
                                <button className="btn-cancel" onClick={() => setEditingRustikCap({ index: null, value: '' })}><i className="fas fa-times"></i></button>
                              </div>
                            </div>
                          ) : (
                            <>
                              <span className="item-text">{item}</span>
                              <div className="item-actions">
                                <button className="btn-edit" onClick={() => setEditingRustikCap({ index, value: item })}><i className="fas fa-edit"></i></button>
                                <button className="btn-delete" onClick={() => {
                                  const newList = rustikExtras.ayakCapList.filter((_, i) => i !== index);
                                  setRustikExtras({ ...rustikExtras, ayakCapList: newList });
                                  handleSaveSettings({ rustikAyakCapList: newList });
                                }}><i className="fas fa-trash-alt"></i></button>
                              </div>
                            </>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>

            {/* Ayak Uzunluk Listesi */}
            <div className="settings-column">
              <div
                className="settings-sub-header clickable"
                onClick={() => setIsRustikUzunlukCollapsed(!isRustikUzunlukCollapsed)}
              >
                <h4><i className="fas fa-arrows-alt-v"></i> {t('productList.rustikSettings.footLengthList', 'Ayak Uzunluk Listesi')}</h4>
                <i className={`fas fa-chevron-${isRustikUzunlukCollapsed ? 'down' : 'up'}`}></i>
              </div>

              {!isRustikUzunlukCollapsed && (
                <div className="settings-sub-content">
                  <div className="list-add-form">
                    <input
                      type="text"
                      placeholder={t('productList.rustikSettings.newLengthPlaceholder', 'Yeni Uzunluk')}
                      value={newRustikUzunluk}
                      onChange={(e) => setNewRustikUzunluk(e.target.value)}
                    />
                    <button onClick={() => {
                      if (!newRustikUzunluk) return;
                      const newList = [...rustikExtras.ayakUzunlukList, newRustikUzunluk];
                      setRustikExtras({ ...rustikExtras, ayakUzunlukList: newList });
                      setNewRustikUzunluk('');
                      handleSaveSettings({ rustikAyakUzunlukList: newList });
                    }}><i className="fas fa-plus"></i></button>
                  </div>
                  <div className="settings-list-container">
                    {rustikExtras.ayakUzunlukList.length === 0 && <span className="empty-list-msg">{t('productList.dikeySettings.emptyList', 'Liste boş')}</span>}
                    <ul className="settings-inner-list">
                      {rustikExtras.ayakUzunlukList.map((item, index) => (
                        <li key={index} className="settings-list-item">
                          {editingRustikUzunluk.index === index ? (
                            <div className="edit-mode-container">
                              <input
                                type="text"
                                value={editingRustikUzunluk.value}
                                onChange={(e) => setEditingRustikUzunluk({ ...editingRustikUzunluk, value: e.target.value })}
                                autoFocus
                              />
                              <div className="edit-actions">
                                <button className="btn-confirm" onClick={() => {
                                  const newList = [...rustikExtras.ayakUzunlukList];
                                  newList[index] = editingRustikUzunluk.value;
                                  setRustikExtras({ ...rustikExtras, ayakUzunlukList: newList });
                                  handleSaveSettings({ rustikAyakUzunlukList: newList });
                                  setEditingRustikUzunluk({ index: null, value: '' });
                                }}><i className="fas fa-check"></i></button>
                                <button className="btn-cancel" onClick={() => setEditingRustikUzunluk({ index: null, value: '' })}><i className="fas fa-times"></i></button>
                              </div>
                            </div>
                          ) : (
                            <>
                              <span className="item-text">{item}</span>
                              <div className="item-actions">
                                <button className="btn-edit" onClick={() => setEditingRustikUzunluk({ index, value: item })}><i className="fas fa-edit"></i></button>
                                <button className="btn-delete" onClick={() => {
                                  const newList = rustikExtras.ayakUzunlukList.filter((_, i) => i !== index);
                                  setRustikExtras({ ...rustikExtras, ayakUzunlukList: newList });
                                  handleSaveSettings({ rustikAyakUzunlukList: newList });
                                }}><i className="fas fa-trash-alt"></i></button>
                              </div>
                            </>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>

            {/* Ayak Renk Listesi */}
            <div className="settings-column">
              <div
                className="settings-sub-header clickable"
                onClick={() => setIsRustikRenkCollapsed(!isRustikRenkCollapsed)}
              >
                <h4><i className="fas fa-palette"></i> {t('productList.rustikSettings.footColorCodeList', 'Renk Kodu Listesi')}</h4>
                <i className={`fas fa-chevron-${isRustikRenkCollapsed ? 'down' : 'up'}`}></i>
              </div>

              {!isRustikRenkCollapsed && (
                <div className="settings-sub-content">
                  <div className="list-add-form">
                    <input
                      type="text"
                      placeholder={t('productList.rustikSettings.newColorPlaceholder', 'Yeni Renk')}
                      value={newRustikRenk}
                      onChange={(e) => setNewRustikRenk(e.target.value)}
                    />
                    <button onClick={() => {
                      if (!newRustikRenk) return;
                      const newList = [...rustikExtras.ayakRenkKoduList, newRustikRenk];
                      setRustikExtras({ ...rustikExtras, ayakRenkKoduList: newList });
                      setNewRustikRenk('');
                      handleSaveSettings({ rustikAyakRenkKoduList: newList });
                    }}><i className="fas fa-plus"></i></button>
                  </div>
                  <div className="settings-list-container">
                    {rustikExtras.ayakRenkKoduList.length === 0 && <span className="empty-list-msg">{t('productList.dikeySettings.emptyList', 'Liste boş')}</span>}
                    <ul className="settings-inner-list">
                      {rustikExtras.ayakRenkKoduList.map((item, index) => (
                        <li key={index} className="settings-list-item">
                          {editingRustikRenk.index === index ? (
                            <div className="edit-mode-container">
                              <input
                                type="text"
                                value={editingRustikRenk.value}
                                onChange={(e) => setEditingRustikRenk({ ...editingRustikRenk, value: e.target.value })}
                                autoFocus
                              />
                              <div className="edit-actions">
                                <button className="btn-confirm" onClick={() => {
                                  const newList = [...rustikExtras.ayakRenkKoduList];
                                  newList[index] = editingRustikRenk.value;
                                  setRustikExtras({ ...rustikExtras, ayakRenkKoduList: newList });
                                  handleSaveSettings({ rustikAyakRenkKoduList: newList });
                                  setEditingRustikRenk({ index: null, value: '' });
                                }}><i className="fas fa-check"></i></button>
                                <button className="btn-cancel" onClick={() => setEditingRustikRenk({ index: null, value: '' })}><i className="fas fa-times"></i></button>
                              </div>
                            </div>
                          ) : (
                            <>
                              <span className="item-text">{item}</span>
                              <div className="item-actions">
                                <button className="btn-edit" onClick={() => setEditingRustikRenk({ index, value: item })}><i className="fas fa-edit"></i></button>
                                <button className="btn-delete" onClick={() => {
                                  const newList = rustikExtras.ayakRenkKoduList.filter((_, i) => i !== index);
                                  setRustikExtras({ ...rustikExtras, ayakRenkKoduList: newList });
                                  handleSaveSettings({ rustikAyakRenkKoduList: newList });
                                }}><i className="fas fa-trash-alt"></i></button>
                              </div>
                            </>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="settings-card-footer">
            <SettingsSaveButton
              onClick={() => handleSaveSettings()}
              isSaving={isSavingSettings}
              label={t('common.saveSettings', 'Ayarları Kaydet')}
            />
          </div>
        </div>
      )}
    </div>
  );
});

export default RustikSettings;
